import { render, staticRenderFns } from "./DniFieldRegister.vue?vue&type=template&id=872de49c&"
import script from "./DniFieldRegister.vue?vue&type=script&lang=ts&"
export * from "./DniFieldRegister.vue?vue&type=script&lang=ts&"
import style0 from "./DniFieldRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports